import moment from 'moment'
import { hasValue } from 'utils/NumberUtil'
import { DOCUMENT, PICTURE } from '../constant/FileConstants'
import ApplicationConf from 'conf/ApplicationConf'
import { SAMPLE_POINT_SEPARATOR } from '../../../utils/FileUtils'

export default class DtoFile {
    constructor(obj, fileType = DOCUMENT) {
        const pointIndex = obj.name.lastIndexOf('.')
        this.code = obj.code
        this.name = obj.name
        this.url = fileType === PICTURE ? ApplicationConf.picture.pictureCompressPath(obj.name) : obj.url
        this.updateDate = obj.updateDate
        if (obj.name.includes(SAMPLE_POINT_SEPARATOR)) { // https://www.youtube.com/watch?v=Pqoe2aBUI9A
            const [fullName, point] = obj.name.slice(obj.stationCode?.length + 1, pointIndex).split(SAMPLE_POINT_SEPARATOR)
            this.extractFromFullName(fullName)
            this.samplePointSuffix = point || undefined
        } else {
            this.extractFromFullName(obj.name.slice(obj.stationCode?.length + 1, pointIndex))
        }
        const stationCode = obj.name.slice(0, obj.name.indexOf('_'))
        this.stationCode = obj.stationCode || stationCode
        this.fileType = fileType
    }

    extractFromFullName(fullName) {
        const sliced = fullName.split('_')
        const [,, shortNameOld, dateOld] = sliced
        const [type, active, date, stationTypeOrShortName, shortName] = sliced
        this.isAllDataName = sliced.length === 4 || sliced.length === 5
        this.type = type
        this.active = active || '0'
        this.shortName = new RegExp('^[0-9]+-[0-9]+$').test(date) ? (shortName || stationTypeOrShortName) : shortNameOld
        this.date = new RegExp('^[0-9]+-[0-9]+$').test(date) ? moment(date, 'YYYYMMDD-HHmmss').valueOf() : parseInt(dateOld)
        this.stationType = shortName ? stationTypeOrShortName : null
        this.shared = !hasValue(shortName)
    }
}